// @ts-nocheck
import * as React from 'react'
import classnames from 'classnames'
import { Props } from './types'
import SVG from 'react-inlinesvg'
const ICON_BLIINK = require('@App/assets/icon-bliink.svg')
import './styles.scss'
import FormatText from '@App/helpers/formatText'

const Loading: React.FunctionComponent<any> = ({ active }: Props) => {
  const [isFinished, setFinished] = React.useState(false)

  React.useEffect(() => {
    const loadingDOM = document.querySelector('.loading-transition') as HTMLElement

    if (loadingDOM) {
      loadingDOM.addEventListener('transitionend', () => {
        setFinished(true)
      })
    }
  })

  const opacityTransition = () => {
    return {
      opacity: active ? 0 : 1,
      zIndex: active ? '-999' : '999',
    }
  }

  if (isFinished) {
    return null
  }

  return (
    (
      <div
        className={classnames('loadingApp loading-transition')}
        style={opacityTransition()}
      >
        <div className="loading__wrapper">
          {<SVG className="fade-loop" src={FormatText.formatSVGBase64(ICON_BLIINK)} />}
        </div>
      </div>
    )
  )
}

export default Loading
